import { diagnosisItems } from "./diagnosisItems";

// Ref 13/14: Additional Risk Factor identified since registration (+ year).
// Same enum ids AND labels as the registration reasons (diagnosisItems) — the
// `name` is sourced from there so the two lists can never drift — but with
// distinct RHF field keys so they never collide with the registration booleans.
const NAME_BY_ID = Object.fromEntries(
  diagnosisItems.map((item) => [item.id, item.name])
);

export const additionalRiskFactorItems = [
  { field: "additionalQrisk3", id: "QRISK_GTE_20" },
  {
    field: "additionalHypertenstionStage1NoTargetOrganDamage",
    id: "HYPERTENSION_STAGE_1_NO_TARGET_ORGAN_DAMAGE",
  },
  {
    field: "additionalHypertenstionStage1",
    id: "HYPERTENSION_STAGE_1_WITH_TARGET_ORGAN_DAMAGE",
  },
  {
    field: "additionalHypertenstionStage2",
    id: "HYPERTENSION_STAGE_2_OR_3",
  },
  { field: "additionalGestationalDiabetes", id: "GESTATIONAL_DIABETES" },
  { field: "additionalPreEclampsia", id: "PRE_ECLAMPSIA" },
  { field: "additionalPreDiabetes", id: "PRE_DIABETES" },
  { field: "additionalPreviousBNP", id: "PREVIOUS_HIGH_BNP" },
].map((item) => ({ ...item, name: NAME_BY_ID[item.id] }));
